import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { getMyTeamTimesheetList } from "apiHandler/actions";
import { DataGridCustomPagination } from "components/helpers";
import { IconButton } from "@mui/material";
import EditIcon from "@material-ui/icons/Edit";
import { useUserData } from "components/customHooks/userDataContext";
import { useNavigate } from "react-router-dom";

const TeamTimeSheetTable = () => {
  const navigate = useNavigate();
  const userData = useUserData();
  const [provider, setProvider] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    const timeSheetPayload = { user_id: userData?.email };
    const timeSheetsResponse = await getMyTeamTimesheetList(timeSheetPayload);

    setLoading(false);
    if (timeSheetsResponse) {
      const reverseTimeSheet = timeSheetsResponse.reverse();
      setProvider(
        reverseTimeSheet.map((p, index) => ({
          ...p,
          id: index,
          week_start_date: p.week_start_date
            ? p.week_start_date.slice(0, 16)
            : "",
          created_date: p.created_date ? p.created_date.slice(0, 16) : "",
          last_updated_date: p.last_updated_date
            ? p.last_updated_date.slice(0, 16)
            : "",
        }))
      );
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleOnEditClick = (data) => {
    navigate("/teamtimesheet", data);
  };

  const columns = [
    {
      field: "",
      headerName: "",
      width: 50,
      align: "center",
      renderCell: (e) => (
        <IconButton onClick={() => handleOnEditClick(e.row)} color="secondary">
          <EditIcon />
        </IconButton>
      ),
    },
    {
      field: "user_signature",
      headerName: "Employee Name",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "created_date",
      headerName: "Create Date",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "last_updated_date",
      headerName: "Last Update",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "week_start_date",
      headerName: "Week Start Date",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "total_work_hrs",
      headerName: "Total Work Hours",
      minWidth: 170,
      flex: 1,
    },
  ];

  return (
    <div className="grid-cont">
      <div className="header">
        <h3>List</h3>
      </div>
      <DataGrid
        pageSize={10}
        density="compact"
        rows={provider}
        columns={columns}
        loading={loading}
        autoHeight
        disableRowSelectionOnClick
        pagination
        slots={{
          pagination: DataGridCustomPagination,
          toolbar: GridToolbar,
        }}
      />
    </div>
  );
};

export default TeamTimeSheetTable;
